<div class="{{field.customClass}}" >
	<div class="row title-container">
	<div class="text-center" *ngIf="field.DisplayText">
		<h2>{{ field.DisplayText }}</h2>
	</div>
</div>

<p-table [value]="arrayChilds">
	<ng-template pTemplate="caption">
		<div class="d-flex align-items-center justify-content-between">
			<div class="d-flex align-items-center">
				<span class="me-2" *ngIf="field.UIOptions?.ArrayFieldOptions?.CaptionText">
					{{ field.UIOptions.ArrayFieldOptions.CaptionText }}
				</span>
				<span class="badge rounded-pill bg-secondary"
					  *ngIf="field.UIOptions?.ArrayFieldOptions?.ShowCount">
					{{ arrayChilds?.length || 0 }}
				</span>
			</div>

			<button type="button" pButton [label]="field.ButtonText" icon="pi pi-plus"
					class="p-button-sm p-button-outlined" (click)="createChild()"></button>
		</div>
	</ng-template>
	<ng-template pTemplate="header">
		<tr>
			<th *ngFor="let header of field.UIOptions.ArrayFieldOptions.TableHeaders">
				{{ header }}
			</th>
			<th>Actions</th>
		</tr>
	</ng-template>
	<ng-template pTemplate="body" let-formFieldChild let-rowIndex="rowIndex">
		<tr>
			<td *ngFor="let childField of formFieldChild">
				<cv-form-field [options]="{
			  					key: field.Name,
			  					path: field.path,
			  					index: rowIndex,
			  					childKey: childField.key
							}">
				</cv-form-field>
			</td>

			<td>
				<button (click)="deleteChild(rowIndex)" pButton type="button" pbutton="" icon="pi pi-trash"
						ptooltip="Delete Row" class="p-button-rounded p-button-text p-button-danger"></button>
			</td>
		</tr>
	</ng-template>
	<ng-template pTemplate="emptymessage">
			<tr class="empty-message-row">
				<td class="text-center"
					[attr.colspan]="(field.UIOptions.ArrayFieldOptions.TableHeaders?.length || 0) + 1">
					No items added yet.
				</td>
			</tr>
	</ng-template>
</p-table>
</div>